jQuery(document).ready(function ($) {

    var Marshall = (function () {

        var sameHeight = function () {

            $('.grid-services .item').matchHeight();

            enquire.register("screen and (min-width: 992px)", {
                match: function () {

                    $('.location-top-content .sameHeight').matchHeight();
                    $('.squares-grid .sameHeight').matchHeight();

                },
                unmatch: function () {

                }
            });


            enquire.register("screen and (min-width: 768px)", {
                match: function () {

                    $('.intro-content .sameHeight').matchHeight();

                },
                unmatch: function () {

                }
            });

        };

        var mainNav = function () {

            $('ul#main-menu.desktop-nav li').hover(
                function () {
                    $(this).addClass('hover');
                },
                function () {
                    $(this).removeClass('hover');
                }
            );

            enquire.register("screen and (max-width: 767px)", {
                match: function () {

                    $('ul.main-nav > li.dropdown > a').on('click', function (e) {
                        e.preventDefault();
                        $(this).next().slideToggle().toggleClass('open');
                    });

                    $('ul.main-nav > li.dropdown > ul.dropdown-menu > li.dropdown > a').on('click', function (e) {
                        e.preventDefault();
                        $(this).next().slideToggle().toggleClass('open');
                    });

                },
                unmatch: function () {

                }
            });

        };

        var smoothScroll = function () {
            $('.contents-table').smoothScroll();
            $('.back-to-top-wrap').smoothScroll();
            $('.text-wrap').smoothScroll();

            $('.box-jumpto').smoothScroll();
            $('.info-details').smoothScroll();
            $('.text-right').smoothScroll();
            $('.text-center').smoothScroll();
        };

        var footerLocation = function () {


            $('.footer-accordion-link').click(function (e) {
                e.preventDefault();
                $(".footer-locations-list li").find("a").removeClass('active');
                $(this).addClass('active');
                $.ajax({
                    type: 'POST',
                    url: cws.ajaxurl,
                    data: {
                        action: 'cws_map_link_ajax_callback',
                        location_id: $(this).attr('data-id')
                    },
                    dataType: 'json',

                    success: function (response) {
                        if (response.success === true) {
                            var arr = response.data.shortCode.split('#');
                            $('.footer-location-details .address').html(arr[0]);

                            map = new google.maps.Map(document.getElementById('map_canvas'), {
                                zoom: 15,
                                center: {lat: parseFloat(arr[1]), lng: parseFloat(arr[2])},
                                mapTypeId: 'roadmap'
                            });

                            var marker;
                            marker = new google.maps.Marker({
                                position: new google.maps.LatLng(parseFloat(arr[1]), parseFloat(arr[2])),
                                map: map,
                                icon: '/wp-content/themes/cws-theme-work/assets/images/custom-marker.png'
                            });
                            marker.setMap(map);

                        } else if (response.success === false) {
                            alert(response.data);
                        }
                    },
                });
            });

        };

        var slickSlider = function () {

            // Featured On Slider            
            $(".featured-list-sidebar").slick({
                slidesToShow: 1,
                infinite: true,
                autoplay: false,
                slidesToScroll: 1,
                initialSlide: 0,
                speed: 300,
                prevArrow: '<span class="icon-chevron-left"></span>',
                nextArrow: '<span class="icon-chevron-right"></span>',
                appendArrows: '.slick-nav-featured-sidebar',
                dots: false
            });

            enquire.register("screen and (max-width: 767px)", {
                match: function () {

                    // Top Logos On Slider
                    $(".intro-logos .grid-logos").slick({
                        slidesToShow: 2,
                        infinite: true,
                        autoplay: false,
                        slidesToScroll: 2,
                        initialSlide: 0,
                        speed: 300,
                        prevArrow: '<span class="icon-chevron-left"></span>',
                        nextArrow: '<span class="icon-chevron-right"></span>',
                        appendArrows: '.slick-nav-logos-sidebar',
                        dots: false,
                        centerMode: true,
                        variableWith: false
                    });

                    // Top Logos On Slider
                    $(".location-logos .grid-logos").slick({
                        slidesToShow: 1,
                        infinite: true,
                        autoplay: false,
                        slidesToScroll: 1,
                        initialSlide: 0,
                        speed: 300,
                        prevArrow: '<span class="icon-chevron-left"></span>',
                        nextArrow: '<span class="icon-chevron-right"></span>',
                        appendArrows: '.slick-nav-logos-sidebar',
                        dots: false,
                        centerMode: true,
                        variableWith: false
                    });

                    // Meet Team Attorneys On Slider
                    $(".meet-team .grid-team").slick({
                        slidesToShow: 1,
                        infinite: true,
                        autoplay: false,
                        slidesToScroll: 1,
                        initialSlide: 0,
                        speed: 300,
                        prevArrow: '<span class="icon-chevron-left"></span>',
                        nextArrow: '<span class="icon-chevron-right"></span>',
                        appendArrows: '.slick-nav-team',
                        dots: false,
                        centerMode: true,
                        variableWith: false
                    });



                },
                unmatch: function () {

                }
            });



            //Awards Sidebar Slider
            $(".awards-list").slick({
                slidesToShow: 5,
                infinite: true,
                autoplay: false,
                slidesToScroll: 5,
                initialSlide: 0,
                speed: 300,
                prevArrow: '<span class="icon-chevron-left"></span>',
                nextArrow: '<span class="icon-chevron-right"></span>',
                appendArrows: '.slick-nav-awards',
                dots: false,
                variableWith: true,
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            dots: false,
                            infinite: true,
                            speed: 300,
                            slidesToShow: 4,
                            slidesToScroll: 4
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            dots: false,
                            infinite: true,
                            speed: 300,
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            dots: false,
                            infinite: true,
                            speed: 300,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: true,
                            variableWith: false,
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object

                ]
            });

        };

        var requiredInput = function () {

            $('.input-email').on('focus', function () {
                if ($(this).parent().data('required') == 'required') {
                    $(this).parent().removeClass('required');
                }
            });

            $('.input-email').on('blur', function () {
                if ($(this).val() == '') {
                    $(this).parent().addClass('required');
                }
            });

            $('.input-required').on('focus', function () {
                if ($(this).parent().data('required') == 'required') {
                    $(this).parent().removeClass('required');
                }
            });

            $('.input-required').on('blur', function () {
                if ($(this).val() == '') {
                    $(this).parent().addClass('required');
                }
            });

        };

        var credentialsAccordion = function () {

            $('.credentials-accordion').on('click', '.panel-title a', function () {

                $link = $('.credentials-accordion .panel-title a');

                if( $(this).hasClass('opened') ) {
                    $(this).removeClass('opened');
                } else {
                    $link.removeClass('opened');
                    $(this).addClass('opened');
                }

            });

            $('.practice-area-content .col-right ul li a span').each(function () {

                if( $(this).outerHeight() > 25) {
                    $(this).addClass('custom-arrow');
                }

            });

        };

        var faqs = function () {

            $("#commentform").addClass("noauto");

            $('.qa-faqs h3 a').on('click', function (event) {
                event.preventDefault();
                $(this).stop().toggleClass('active');
                $(this).parent().toggleClass('open');

            });

        };

        return {

            init: function () {
                smoothScroll();
                footerLocation();
                slickSlider();
                mainNav();
                sameHeight();
                requiredInput();
                credentialsAccordion();
                faqs();
            }

        }

    })();

    Marshall.init();

});